import * as React from 'react';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import merge from 'lodash/merge';
import { createTheme, CssBaseline } from '@material-ui/core';

const theme = createTheme({
  palette: {
    error: {
      main: '#ff0000',
    },
  },
});

const overrideTheme = (theme) => {
  merge(theme.overrides, {
    Option: {
      text: {
        width: '100%',
      },
    },
    ProductPart: {
      icon: {
        display: 'none',
      },
      content: {
        '&.vertical': {
          justifyContent: 'center',
          textAlign: 'left',
          alignItems: 'start',
        },
      },
    },
    SaveConfiguration: {
      copyShareUrlIcon: {
        display: 'none',
      },
    },
  });
};

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <ConnectedThemeProvider customTheme={theme} withTheme={overrideTheme}>
      <CssBaseline />
      {children}
    </ConnectedThemeProvider>
  );
};

export default ThemeProvider;
